import { render, staticRenderFns } from "./HoraProductiva.vue?vue&type=template&id=1bed1580&"
import script from "./HoraProductiva.vue?vue&type=script&lang=js&"
export * from "./HoraProductiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports